<template>
  <div class="ts-p-4">
    <div class="ts-flex ts-space-x-4">
      <div class="ts-whitespace-no-wrap">
        <a-radio-group v-model="stockType" @change="fetchBorrowing">
          <a-radio-button value="vendor">Vendor</a-radio-button>
          <a-radio-button value="customer">Customer</a-radio-button>
        </a-radio-group>
      </div>
      <a-select
        v-model="selectedBorrowing"
        style="width: 100%"
        placeholder="Please borrowing spare part"
        :options="borrowingSparePart"
        @change="fetchProduct"
      ></a-select>
    </div>
    <table class="ts-w-full ts-mt-4">
      <thead>
        <tr class="ts-bg-blue-100">
          <th class="ts-text-sm ts-py-1 ts-px-2">
            {{ $t('task.productName') }}
          </th>
          <th class="ts-text-sm ts-py-1 ts-px-2 ts-w-48">
            {{ $t('task.uom') }}
          </th>
          <th class="ts-text-sm ts-py-1 ts-px-2 ts-w-24">
            {{ $t('task.quantity') }}
          </th>
          <th class="ts-text-sm ts-py-1 ts-px-2 ts-w-56">
            {{ $t('task.remark') }}
          </th>
          <th class="ts-text-sm ts-py-1 ts-px-2 ts-w-24 ts-text-center">
            <a href="#" @click.prevent="addRow"
              ><Icon type="md-add-circle" size="25"
            /></a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(p, index) in model.products" :key="index">
          <td class="ts-font-roboto ts-text-base ts-py-1 ts-px-2" valign="top">
            <Select
              v-model="p.product_id"
              :filterable="true"
              style="width:100%"
              @on-change="onProductChange(p)"
            >
              <Option
                v-for="item in products"
                :value="item.product_id"
                :key="item.product_id + item.sfo_id"
                >{{ item.product_name_en }}</Option
              >
            </Select>
            <div
              v-if="errors.has('products.' + index + '.product_id')"
              class="ts-text-red-600"
            >
              {{ errors.first('products.' + index + '.product_id') }}
            </div>
          </td>
          <td class="ts-font-roboto ts-text-base ts-py-1 ts-px-2" valign="top">
            <Select
              v-model="p.uom_id"
              :filterable="true"
              style="width:100%"
              @on-change="onGetPrice(p)"
            >
              <Option
                v-for="item in uomList(p.product_id)"
                :value="item.uom_id"
                :key="item.uom_id"
                >{{ item.uom_name_en }}</Option
              >
            </Select>
            <div
              v-if="errors.has('products.' + index + '.uom_id')"
              class="ts-text-red-600"
            >
              {{ errors.first('products.' + index + '.uom_id') }}
            </div>
          </td>
          <td
            class="ts-text-base ts-text-center ts-py-1 ts-px-2 ts-w-24"
            valign="top"
          >
            <Input
              type="number"
              v-model.number="p.quantity"
              placeholder="Quantity"
              style="width: 100%"
            />
            <div
              v-if="errors.has('products.' + index + '.quantity')"
              class="ts-text-red-600"
            >
              {{ errors.first('products.' + index + '.quantity') }}
            </div>
          </td>
          <td class="ts-text-base ts-text-left ts-py-1 ts-px-2" valign="top">
            <Input
              type="text"
              v-model="p.remark"
              placeholder="Remark"
              style="width: 100%"
            />
          </td>
          <td class="ts-text-base ts-py-1 ts-px-2 ts-text-center" valign="top">
            <a href="#" @click.prevent="remove(index)"
              ><Icon type="md-close" size="20" class="ts-text-red-600"
            /></a>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div class="row">
      <div
        class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
      >
        <button
          @click.prevent="$emit('cancel')"
          class="ts-px-6 ts-py-2 ts-flex ts-items-center ts-justify-center ts-text-black ts-font-semibold ts-font-robot ts-rounded-lg focus:ts-outline-none"
          style="background: rgba(214, 214, 214, 0.7);"
        >
          {{ $t('cancel') }}
        </button>
        <button
          class="ts-px-6 ts-py-2 ts-flex ts-items-center ts-justify-center ts-text-white ts-font-semibold ts-font-robot ts-rounded-lg  focus:ts-outline-none"
          style="background: rgba(1, 99, 151, 0.7);"
          @click.prevent="onReport"
        >
          {{ $t('save') }}
        </button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      products: [],
      uom: [],
      borrowingSparePart: [],
      errors: new Errors(),
      stockType: 'vendor',
      selectedBorrowing: [],
      model: {
        products: [
          {
            product_id: undefined,
            uom_id: '',
            unit_price: 0,
            remark: '',
            sfo_id: ''
          }
        ]
      }
    }
  },
  computed: {
    uomList: vm => productId => {
      let findProduct = vm.products.find(p => p.product_id == productId)
      if (findProduct) {
        return vm.uom.filter(u => u.uom_cat_id == findProduct.uom_cat_id)
      }
      return []
    }
  },
  created() {
    this.fetchBorrowing()
    this.fetchUom()
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['report', 'formViewModel']),
    addRow() {
      this.model.products.push({
        product_id: '',
        uom_id: '',
        unit_price: 0,
        remark: '',
        sfo_id: ''
      })
    },
    remove(index) {
      this.model.products.splice(index, 1)
    },
    fetchProduct(value) {
      this.loading = true
      this.formViewModel({
        fnName: 'product',
        sfoId: value
      })
        .then(response => {
          this.products = response.data.product
        })
        .finally(() => (this.loading = false))
    },
    fetchUom() {
      this.loading = true
      this.formViewModel({
        fnName: 'uom'
      })
        .then(response => {
          this.uom = response.data.uom
        })
        .finally(() => (this.loading = false))
    },
    fetchBorrowing() {
      this.selectedBorrowing = []
      this.model.products = []
      this.addRow()
      this.loading = true
      this.formViewModel({
        fnName: 'borrowingSparePart',
        stockType: this.stockType
      })
        .then(response => {
          this.borrowingSparePart = response.data.borrowingSparePart.map(
            el => ({
              value: el.sfo_id,
              label: el.sfo_number
            })
          )
        })
        .finally(() => (this.loading = false))
    },
    onProductChange(row) {
      if (row.product_id === undefined) return
      let findProduct = this.products.find(p => p.product_id == row.product_id)
      let defaultUom = this.uom.find(
        u => u.uom_cat_id == findProduct.uom_cat_id && u.is_default == true
      )
      row.uom_id = defaultUom.uom_id

      // get sfo id
      const sfo = this.products.find(el => el.product_id == row.product_id)
      row.sfo_id = sfo.sfo_id

      this.onGetPrice(row)
    },
    onGetPrice(row) {
      if (row.uom_id) {
        this.loading = true
        this.formViewModel({
          fnName: 'getSalePrice',
          product_id: row.product_id,
          uom_id: row.uom_id
        })
          .then(response => {
            row.unit_price = response.data.getSalePrice[0].sale_price
          })
          .finally(() => (this.loading = false))
      }
    },
    onReport() {
      this.loading = true
      this.report({
        id: this.$route.params.id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close', false)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
